import React from 'react';
import './categories.scss';

const ICON_BASE = `${process.env.PUBLIC_URL}/img/gcm/categories`;

// Category icon from the Gift Card Market set. The SVG is used as a mask and filled
// with the text colour, so one file serves both states: gray normally, the program's
// theme colour on hover/focus and for the current category (see categories.scss).
const assetIcon = (name) => {
    const CategoryIcon = ({ size = 48, className = '' }) => (
        <span className={`gcm-cat-icon ${className}`} style={{ width: size, height: size }} aria-hidden="true">
            <span className="gcm-cat-icon__shape" style={{ '--gcm-cat-icon': `url(${ICON_BASE}/${name}.svg)` }} />
        </span>
    );
    return CategoryIcon;
};

const RestaurantIcon = assetIcon('restaurant');
const PatioIcon = assetIcon('patio');
const SpaIcon = assetIcon('spa');
const EntertainmentIcon = assetIcon('entertainment');
const BestSellerIcon = assetIcon('best-sellers');
const HomeIcon = assetIcon('home');
const AutoIcon = assetIcon('car');
const PersonalServicesIcon = assetIcon('personal');

// The asset icons carry ~20% padding inside their frame; this card photo has none,
// so it's drawn smaller to sit at the same visual size as its neighbours.
const LocalChoiceCardIcon = ({ size = 48, className }) => (
    <img
        className={className}
        src={`${process.env.PUBLIC_URL}/img/gcm/local-choice-card.png`}
        alt=""
        style={{ height: Math.round(size * 0.75), width: 'auto', margin: `${Math.round(size * 0.125)}px 0` }}
    />
);

// `key` is the GCM card program sent to the API. Two categories currently share
// the restaurant program, so `id` is what identifies the selected button.
// `labelLines` holds the mockup's two-line label breaks for the tab layouts.
export const STATIC_CATEGORIES = [
    { id: 'restaurants',        key: 'choose_your_own_restaurant',        label: 'Restaurants',                                           Icon: RestaurantIcon },
    { id: 'patio',              key: 'choose_your_own_dra',               label: 'Patio Season',       labelLines: 'Patio\nSeason',       Icon: PatioIcon },
    { id: 'local-choice-cards', key: 'choose_your_own_restaurant',        label: 'Local Choice Cards', labelLines: 'Local Choice\nCards', Icon: LocalChoiceCardIcon },
    { id: 'spas',               key: 'choose_your_own_spa',               label: 'Spas & Salons',      labelLines: 'Spas &\nSalons',      Icon: SpaIcon },
    { id: 'entertainment',      key: 'choose_your_own_entertainment',     label: 'Entertainment',                                         Icon: EntertainmentIcon },
    { id: 'best-sellers',       key: 'choose_your_own_best_sellers',      label: 'Best-Sellers',       labelLines: 'Best-\nSellers',      Icon: BestSellerIcon },
    { id: 'home-services',      key: 'choose_your_own_home_services',     label: 'Home Services',      labelLines: 'Home\nServices',      Icon: HomeIcon },
    { id: 'auto-services',      key: 'choose_your_own_auto',              label: 'Auto Services',      labelLines: 'Auto\nServices',      Icon: AutoIcon },
    { id: 'personal-services',  key: 'choose_your_own_personal_services', label: 'Personal Services',  labelLines: 'Personal\nServices',  Icon: PersonalServicesIcon },
];

export const categoryPath = ({ id }) =>
    `/participant/gcm-category?c=${encodeURIComponent(id)}`;

// One category tab. Hover/focus and the current category (`active`, exposed as
// aria-current) get the theme-colour icon, a bold label and an underline — see
// categories.scss. `multiline` uses the mockup's two-line label breaks.
export const CategoryTab = ({ category, className, iconSize, multiline = false, active = false, onClick }) => {
    const label = multiline ? category.labelLines || category.label : category.label;
    return (
        <button
            type="button"
            className={`gcm-tab ${className}`}
            aria-current={active ? 'page' : undefined}
            onClick={onClick}
        >
            <category.Icon className={`${className}__icon`} size={iconSize} />
            <span className={`gcm-tab__label ${className}__label`} data-label={label}>{label}</span>
        </button>
    );
};
